import React, { FC } from 'react';
import { IconButton, ListItem, ListItemIcon, Menu } from '@mui/material';
import { getInitials } from 'utilities';
import {
  MenuItemsLabel,
  SecondaryButton,
  SecondaryLink,
  StyledArrowRight,
  StyledAvatar,
  StyledListItemText,
  StyledMenuItem,
} from './styles';
import { IBottomMenuItem, IIconButtonOnClickEvent } from './types';

const ITEM_HEIGHT = 350;

const BottomMenuItem: FC<IBottomMenuItem> = props => {
  const { item, anchorElement, setAnchorElement } = props;

  const handleMenuClick = (event: IIconButtonOnClickEvent<HTMLSpanElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorElement(null);
  };

  return (
    <>
      <ListItem>
        <ListItemIcon>
          {item.imageUrl || item?.displayAvatar ? (
            <StyledAvatar src={item.imageUrl} />
          ) : (
            <StyledAvatar>{getInitials({ name: item.primaryText })}</StyledAvatar>
          )}
        </ListItemIcon>

        <StyledListItemText
          primary={item.primaryText}
          secondary={
            item?.isLink ? (
              <SecondaryLink to={item.slug}>{item.secondaryText}</SecondaryLink>
            ) : (
              item?.handleButtonClick && (
                <SecondaryButton onClick={item.handleButtonClick} type="button">
                  {item.secondaryText}
                </SecondaryButton>
              )
            )
          }
        />

        {item.subItems && item.subItems.length > 0 && (
          <IconButton
            aria-controls={item.slug}
            aria-haspopup="true"
            aria-label="more"
            component="span"
            id={`${item.slug}-button`}
            onClick={handleMenuClick}>
            <StyledArrowRight fontSize="small" />
          </IconButton>
        )}
      </ListItem>

      {/* Submenu */}
      {item.subItems && item.subItems.length > 0 && (
        <Menu
          id={`sidebar-bottom-dropdown-${item.slug}`}
          anchorEl={anchorElement}
          open={anchorElement ? anchorElement.getAttribute('aria-controls') === item.slug : false}
          onClose={handleMenuClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT,
            },
            square: true,
          }}>
          {item.subItemsLabel && <MenuItemsLabel>{item.subItemsLabel}</MenuItemsLabel>}

          {item.subItems.map(option => (
            <div key={`subitem-${option.slug}`}>
              <StyledMenuItem
                key={option.slug}
                onClick={() => {
                  option.handleItemClick();
                  handleMenuClose();
                  // TODO: Close sidebar
                }}>
                {option?.icon && option.icon} {option.title}
              </StyledMenuItem>
            </div>
          ))}
        </Menu>
      )}
    </>
  );
};

export default BottomMenuItem;
